var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBmStage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 9H9V22H23V9Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3027 15.5503L16.4483 15.2681L17.1436 13.9202C17.1651 13.8773 17.1732 13.8333 17.1701 13.791C17.1668 13.7483 17.1517 13.7034 17.1216 13.6606C17.0912 13.6174 17.0457 13.5768 16.9857 13.5469C16.9254 13.517 16.8551 13.5 16.7816 13.5L16.3027 15.5503ZM16.3027 15.5503L16.4962 15.802M16.3027 15.5503L16.4962 15.802M16.4962 15.802L17.472 17.0718C17.4918 17.1106 17.5006 17.1508 17.5 17.1894C17.4993 17.2336 17.486 17.2801 17.4571 17.3247C17.4278 17.3698 17.3824 17.4127 17.321 17.4446C17.2595 17.4766 17.1867 17.4948 17.1104 17.4949H15.3929H15.2313M16.4962 15.802L15.2313 17.4949M15.2313 17.4949L15.1003 17.5894M15.2313 17.4949L15.1003 17.5894M15.1003 17.5894L14.5 18.0226V13.8088C14.5 13.8088 14.5 13.8088 14.5 13.8087C14.5 13.743 14.5283 13.6692 14.5969 13.6069C14.6671 13.543 14.7716 13.5 14.8892 13.5M15.1003 17.5894L14.8892 13.5M14.8893 13.5H16.7815H14.8893ZM14.8893 13.5C14.8893 13.5 14.8892 13.5 14.8892 13.5M14.8893 13.5H14.8892"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9L5.5 6.5V24.5L9 22",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 9L26.5 6.5V24.5L23 22",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 25H20",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 27.5H24",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmStage);
export default __webpack_public_path__ + "static/media/BM_Stage.2943ccf5e825d3fafc2c6aec97097ca3.svg";
export { ForwardRef as ReactComponent };